import { handleSubmit } from '../ProgressiveFormStepper/utils';

/**
 *
 * @param stateProps
 * @param formikProps
 * @param close
 */
export const handleClose = (stateProps, formikProps, close) => {
  close();
  const props = {};
  props.stateProps = stateProps;
  props.formikProps = formikProps;
  handleSubmit(props, 'menu');
};

/**
 *
 * @param stateProps
 * @param message
 * @returns {[string,string|*]}
 */
export const getMessage = (stateProps, message) => {
  let returnHeader = 'Success';
  const returnMessage = typeof stateProps.sectionData.modalMessage !== 'undefined' ? stateProps.sectionData.modalMessage : message;
  if (returnMessage.indexOf('not downloaded') > 0) {
    returnHeader = 'Whoops!';
  }
  return [returnHeader, returnMessage];
};


